var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "progressContainer",
      staticClass: "chapter-progress",
      attrs: { "aria-hidden": "true" },
      on: {
        mouseout: _vm.progressOut,
        mousemove: function($event) {
          if (!$event.altKey) {
            return null
          }
          return _vm.progressMove($event)
        },
        click: [
          function($event) {
            if (
              $event.ctrlKey ||
              $event.shiftKey ||
              $event.altKey ||
              $event.metaKey
            ) {
              return null
            }
            return _vm.progressClick($event)
          },
          function($event) {
            if (!$event.altKey) {
              return null
            }
            return _vm.contextProgressClick($event)
          }
        ]
      }
    },
    [
      _c("span", { staticClass: "title", attrs: { "aria-hidden": "true" } }, [
        _vm._v("\n    " + _vm._s(_vm.chapter.title) + "\n  ")
      ]),
      _vm._v(" "),
      _vm.hasLink
        ? _c(
            "span",
            { staticClass: "link" },
            [
              _c("icon", { staticClass: "icon", attrs: { type: "link" } }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "info-link",
                  attrs: { href: _vm.chapter.href, target: "_blank" },
                  on: { mouseover: _vm.linkOver, mouseleave: _vm.linkLeave }
                },
                [_vm._v("\n      " + _vm._s(_vm.chapter.linkTitle) + "\n    ")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("timer", {
        staticClass: "timer",
        attrs: {
          time: _vm.remainingTime,
          remaining:
            (_vm.chapter.active || !!_vm.ghostActive) && _vm.playtime > 0
        }
      }),
      _vm._v(" "),
      _c("span", {
        staticClass: "chapter-progress-bar",
        style: _vm.progressStyle,
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v(" "),
      _c("span", {
        staticClass: "chapter-progress-bar",
        style: _vm.progressGhostStyle,
        attrs: { "aria-hidden": "true" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }